export default {
  'pages.home.title': '欢迎来到BEUKAY包材商城',
  'pages.home.subTitle':
    'BEUKAY包材商城，为彩妆、护肤品、香水和化妆品行业设计、开发和制造初级包装容器的世界级领导者；同时也为多家知名国际品牌提供尖端的全球制造协同方案。',
  'pages.home.contact': '联系我们',
  'pages.home.description': '尺寸/简介：',
  'pages.home.news': '最新资讯',
  'pages.home': '首页',
  'pages.home.search': '搜索',
};
